<template>
  <q-dialog v-model="show_login" :position="position" persistent>
    <div class="row justify-center">
      <div class="row justify-center bg-white q-py-lg q-px-xl shadow-2" :style="{ height: 'fit-content' }"
        @click.stop="">
        <q-form dense @submit="onSubmit" @reset="onReset">
          <q-input :dense="$form['dense']" :outlined="$form['outlined']" v-model="login_name" readonly lazy-rules
            class="form_item full-width" :prefix="$form['is_label_in'] ? $t('login_name') + '：' : null" :rules="[
              (val) =>
                (val !== null && val !== '') || $t('please_enter_login_name'),
            ]">
            <template v-if="!$form['is_label_in']" v-slot:before>
              <div class="form_item_label">
                {{ $t("login_name") + "：" }}
              </div>
            </template>
          </q-input>

          <q-input :dense="$form['dense']" :outlined="$form['outlined']" v-model="password" lazy-rules
            class="form_item full-width" :prefix="$form['is_label_in'] ? $t('password') + '：' : null" :rules="[
              (val) =>
                (val !== null && val !== '') || $t('please_enter_password'),
            ]">
            <template v-if="!$form['is_label_in']" v-slot:before>
              <div class="form_item_label">
                {{ $t("password") + "：" }}
              </div>
            </template>
          </q-input>

          <div class="row justify-center content-center q-mt-xm">
            <q-btn class="full-width q-mt-md" :label="$t('login')" type="submit" color="primary"></q-btn>
          </div>
        </q-form>
      </div>
    </div>
  </q-dialog>

  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component class="view" :is="Component" />
      </keep-alive>
    </router-view>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { request } from "@/request/api";
import { useQuasar } from "quasar";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const $q = useQuasar();
    const { locale, t } = useI18n();

    const show_login = ref(false);
    const timeout = 1000 * 60 * 10; // 5分钟，单位为毫秒
    let timer;

    const login_name = ref('');
    const password = ref('');

    // 设置定时器，每隔5分钟执行一次请求
    const intervalId = setInterval(() => {
      if ($q.localStorage.getItem('user_info')) {
        if ($q.localStorage.getItem('user_info').login_name) {
          login_name.value = $q.localStorage.getItem('user_info').login_name;
        }
      }
      request("heartbeat", {}).then((res) => {
        // 这里可以处理返回的结果
        // console.log(res);
      });
    }, 5 * 60 * 1000); // 5分钟，单位为毫秒

    const sendHeartbeat = () => {
      // show_login.value = true;

      // 清除cookies 用户信息 和 权限
      // $q.localStorage.remove("user_info");
      // $q.localStorage.remove("permission");

      // console.log('show Login');
      // resetTimer(); // 发送完心跳后，重新设置定时器
    };

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(sendHeartbeat, timeout);
    };

    const initHeartbeat = () => {
      resetTimer(); // 初始化计时器
      window.addEventListener('mousemove', resetTimer); // 监听鼠标移动事件
      window.addEventListener('keydown', resetTimer); // 监听键盘按下事件
    };

    onMounted(() => {
      initHeartbeat();
    });

    onUnmounted(() => {
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
      clearTimeout(timer);
    });

    function onSubmit() {
      // 检查登录状态
      // console.log(dataForm.value, JSON.stringify(dataForm.value));
      request("check_login", {
        user_name: show_login.value,
        password: password.value,
      }) //函数名以及传参
        .then((res) => {
          console.log(res);
          if (res["status"] == true) {
            // dataForm.value.user_name = "";
            // dataForm.value.password = "";

            let result = {};
            result[t("result")] = t("success");

            save_operation_log(
              res["user_info"]["user_id"],
              res["user_info"]["nickname"],
              t("login"),
              t("login"),
              result
            );

            // console.log(
            //   $q.localStorage.getItem("my_param"),
            //   $q.localStorage.getItem("my_param")
            // );

            if (typeof res["param_me"] != "undefined") {
              $q.localStorage.set("my_param", res["param_me"][0]);
              $q.localStorage.set("sys_param", res["param_me"][1]);
            }

            // console.log(
            //   $q.localStorage.getItem("my_param"),
            //   $q.localStorage.getItem("my_param")
            // );

            $q.notify({
              color: "secondary",
              textColor: "white",
              icon: "fa fa-check",
              message: t("login_success"),
              position: "top",
            });

            // 获取用户信息
            $q.localStorage.set("user_info", res["user_info"]);

            // 获取权限
            $q.localStorage.set("permission", res["permission"]);
          } else {
            $q.notify({
              // type: "negative",
              type: "warning",
              message: t(res["msg"]),
              position: "top",
            });
          }
        });
    }

    return {
      show_login,

      login_name,
      password,

      onSubmit,
    }
  }
};

</script>
